<div class="max-w-[1100px] m-auto">
    <div class="flex flex-col items-center">
        <app-instructions [instructionsRead]="true" [settings]="settings" [deadlineException]="false" [user]="user" (action)="handleInstructionsAction($event)"></app-instructions>
    </div>
</div>